var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9402 2.20983L9.5302 7.81983H7.1202C6.7202 7.81983 6.3302 7.84983 5.9502 7.92983L6.9502 5.52983L6.9902 5.43983L7.0502 5.27983C7.0802 5.20983 7.1002 5.14983 7.1302 5.09983C8.2902 2.40983 9.5902 1.56983 11.9402 2.20983Z",
    fill: "url(#paint0_linear_9868_82847)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7301 8.08953L18.7101 8.07953C18.1101 7.90953 17.5001 7.81953 16.8801 7.81953H10.6201L12.8701 2.58953L12.9001 2.51953C13.0401 2.56953 13.1901 2.63953 13.3401 2.68953L15.5501 3.61953C16.7801 4.12953 17.6401 4.65953 18.1701 5.29953C18.2601 5.41953 18.3401 5.52953 18.4201 5.65953C18.5101 5.79953 18.5801 5.93953 18.6201 6.08953C18.6601 6.17953 18.6901 6.25953 18.7101 6.34953C18.8601 6.85953 18.8701 7.43953 18.7301 8.08953Z",
    fill: "url(#paint1_linear_9868_82847)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2902 9.52031C17.8402 9.39031 17.3702 9.32031 16.8802 9.32031H7.12023C6.44023 9.32031 5.80023 9.45031 5.20023 9.71031C3.46023 10.4603 2.24023 12.1903 2.24023 14.2003V16.1503C2.24023 16.3903 2.26023 16.6203 2.29023 16.8603C2.51023 20.0403 4.21023 21.7403 7.39023 21.9503C7.62023 21.9803 7.85023 22.0003 8.10023 22.0003H15.9002C19.6002 22.0003 21.5502 20.2403 21.7402 16.7403C21.7502 16.5503 21.7602 16.3503 21.7602 16.1503V14.2003C21.7602 11.9903 20.2902 10.1303 18.2902 9.52031ZM14.5002 16.7503H9.50023C9.09023 16.7503 8.75023 16.4103 8.75023 16.0003C8.75023 15.5903 9.09023 15.2503 9.50023 15.2503H14.5002C14.9102 15.2503 15.2502 15.5903 15.2502 16.0003C15.2502 16.4103 14.9102 16.7503 14.5002 16.7503Z",
    fill: "url(#paint2_linear_9868_82847)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9868_82847",
    x1: 8.9452,
    y1: 2.00586,
    x2: 8.9452,
    y2: 7.92983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) calc(h - 42) calc(s - 59) calc(l + 27))"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9868_82847",
    x1: 14.7246,
    y1: 2.51953,
    x2: 14.7246,
    y2: 8.08953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) calc(h - 42) calc(s - 59) calc(l + 27))"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9868_82847",
    x1: 12.0002,
    y1: 9.32031,
    x2: 12.0002,
    y2: 22.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) calc(h - 42) calc(s - 59) calc(l + 27))"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMinus);
export default __webpack_public_path__ + "static/media/wallet-minus.505a70853295efd73cec10a5d7f74320.svg";
export { ForwardRef as ReactComponent };